import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

import AlHoda from "../assets/images/Al Hoda.jpg";
import Jurab from "../assets/images/Jurab.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import "../styles/learn-more.css";

const LearnMore = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="background">
        <div className="learn-more-shell">
          <button
            className="learn-more-back-button"
            onClick={() => window.history.back()}
            type="button"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Back</span>
          </button>

          <header className="learn-more-titlebar">
            <h1 className="learn-more-header">About the Project</h1>
            <hr className="line" />
          </header>

          <section className="archive-story-section">
            <div className="archive-story-copy">
              <p className="paragraph">
                Early Arab immigrants in North and South America have left a
                rich legacy and history. Much of their histories have been
                recorded in millions of pages of Arabic newspapers, books,
                magazines, and other publications. Yet, this rich record has
                been largely inaccessible because it was dispersed, stored in
                disparate archives, and stored in older technologies like
                microfilm. Now, The Khayrallah Center’s Arabic Newspaper
                Database makes these records digitally searchable.
              </p>
              <p className="paragraph">
                The database allows you to search for specific words or
                phrases, and to filter your search by year, publication, and/or
                place of publication. You can look for individuals as they leave
                traces across pages, follow the debates which swirled in early
                Arab Americans communities, read literary works, examine
                political and economic news, and enter the remarkably rich world
                of the <i style={{ fontWeight: "bold" }}>mahjar</i>.
              </p>
            </div>
            <figure className="learn-more-feature-image">
              <img
                src={AlHoda}
                className="image"
                alt="Front page of Al-Hoda newspaper"
              />
            </figure>
          </section>

          <section className="videos">
            <div className="video-grid">
              <article className="video-block">
                <h3 className="section-title">
                  Learn more from the development team behind the archive
                </h3>
                <div className="iframe-container">
                  <iframe
                    src="https://www.youtube.com/embed/woidCJBHwV0"
                    title="Behind the Scenes of the Arab American Newspaper Database"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                    allowFullScreen
                  ></iframe>
                </div>
              </article>
              <article className="video-block">
                <h3 className="section-title">
                  Learn how to use the Arabic Newspaper Database
                </h3>
                <div className="iframe-container">
                  <iframe
                    src="https://www.youtube.com/embed/eC_j70SZTxw?si=zX530F7j_W-fuVVu"
                    title="How to Use the Arabic Newspaper Database"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                    allowFullScreen
                  ></iframe>
                </div>
              </article>
            </div>
          </section>

          <section className="support-section">
            <div className="support-image">
              <img
                src={Jurab}
                className="image"
                alt="Front page of Jurab al-Kurdi newspaper"
              />
            </div>
            <div className="support-copy">
              <p className="paragraph">
                Over the coming months we will continue to add to this tool
                with new capabilities including an Arabic interface and AI, and
                enrich and expand the database with new publications.
              </p>
              <p className="paragraph">
                We welcome your support in maintaining and growing this free
                archive. Please consider donating a{" "}
                <a href="https://lebanesestudies.ncsu.edu/donate/">
                  small gift
                </a>{" "}
                to help sustain our efforts. Also, please let us know of any
                publications that we can add to this archive. You can connect us
                at{" "}
                <a href="mailto:lebanesestudies@ncsu.edu">
                  lebanesestudies@ncsu.edu
                </a>
                .
              </p>
            </div>
          </section>
        </div>
      </div>
      <Footer bgcolor="#fff" />
    </>
  );
};

export default LearnMore;
